// extracted by mini-css-extract-plugin
module.exports = {"header":"ContractDetails_header__1Q1Bs","link":"ContractDetails_link__2_2Lx"};